import './color-input.scss';
import {Box, TextField} from '@mui/material';
import {useContext} from 'react';
import {AppContext} from '../../contexts/app/context';
import {AppContextType} from '../../contexts/app/types';
import {ThemeMode} from '../../enums/theme-mode';

/**
 * Color input field.
 */
export const ColorInput = (props: {
  label: string;
  value: string;
  handleChange: (value: string) => void;
  required?: boolean;
  error?: string;
  id?: string;
  className?: string;
  disabled?: boolean;
  handleBlur?: () => void;
}) => {
  // Get context
  const appContext: AppContextType = useContext(AppContext);

  return (
    <Box className={props.className}>
      <TextField
        id={props.id}
        label={props.label}
        value={props.value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          props.handleChange(event.target.value)
        }
        onBlur={props.handleBlur}
        error={props.error ? true : false}
        helperText={props.error || undefined}
        disabled={props.disabled === true}
        required={props.required === true ? true : false}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        color="neutral"
        type="text"
        fullWidth
        InputProps={{
          startAdornment: (
            <input
              id={`color-input-${props.id}`}
              className={
                appContext.state.currentThemeMode === ThemeMode.Dark
                  ? 'color-input-color-input-dark'
                  : 'color-input-color-input-light'
              }
              value={props.value}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                props.handleChange(event.target.value)
              }
              disabled={props.disabled === true}
              type="color"
            />
          ),
        }}
      />
    </Box>
  );
};
